import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const NotesStore = {
  state: {
    notes: []
  },
  getters,
  mutations,
  actions
}

export default NotesStore